import { calculationTypes } from "./types";
import { alertActions, loading } from "../alert/actions";
import { setCandidateCustomerState } from "../dashboard/actions";
import { history } from "../../../views/components/Home/Home";

import {
  getCampaigns,
  getPaymentPlan,
  saveAddress,
  savePersonalInfo,
  checkIfCustomerHasAddress,
  saveMembership,
  checkPersonalInformation,
  sendSmsOfferValidation,
} from "../../../services/calculation.service";

export const getCampaigns_Begin = (query) => (dispatch) => {
  dispatch(loading.showLoading());
  getCampaigns(query).then(
    (result) => {
      if (result == null) {
        dispatch(
          alertActions.showError(
            "Girmiş olduğunuz değerlere ait kampanya bulunmamaktadır."
          )
        );
      }
      dispatch(getCampaigns_Success(result));
      dispatch(loading.hideLoading());
    },
    (error) => {
      dispatch(getCampaigns_Error(error));
      dispatch(alertActions.error(error));
      dispatch(loading.hideLoading());
    }
  );
};

const getCampaigns_Success = (campaigns) => ({
  type: calculationTypes.GETCAMPAIGNS_SUCCESS,
  payload: {
    campaigns,
  },
});

const getCampaigns_Error = (error) => ({
  type: calculationTypes.GETCAMPAIGNS_ERROR,
  error: error,
});

export const setCampaignsEmpty_Begin = () => (dispatch) => {
  dispatch(setCampaignsEmpty());
};

export const setCampaignsEmpty = () => ({
  type: calculationTypes.GETCAMPAIGNS_SUCCESS,
  payload: {
    campaigns: null,
  },
});

export const toggleCampaignModal = (isCampaignModalOpen) => ({
  type: calculationTypes.TOGGLE_CAMPAIGN_MODAL,
  payload: {
    isCampaignModalOpen,
  },
});

export const getPaymentPlan_Begin = (query, orgTuruId) => (dispatch) => {
  dispatch(loading.showLoading());
  getPaymentPlan(query).then(
    (result) => {
      dispatch(getPaymentPlan_Success(result, orgTuruId));
      dispatch(loading.hideLoading());
    },
    (error) => {
      dispatch(getPaymentPlan_Error(error));
      dispatch(alertActions.error(error));
      dispatch(loading.hideLoading());
    }
  );
};

const getPaymentPlan_Success = (paymentPlan, orgTuruId) => ({
  type: calculationTypes.GETPAYMENTPLAN_SUCCESS,
  payload: {
    paymentPlan,
    orgTuruId,
  },
});

const getPaymentPlan_Error = (error) => ({
  type: calculationTypes.GETPAYMENTPLAN_ERROR,
  error: error,
});

export const toggleAddressModal = (isAddressModalOpen) => ({
  type: calculationTypes.TOGGLE_ADDRESS_MODAL,
  payload: {
    isAddressModalOpen,
  },
});

export const savePersonalInfo_Begin = (obj) => (dispatch) => {
  dispatch(loading.showLoading());
  savePersonalInfo(obj).then(
    (response) => {
      if (response?.code === 2) {
        dispatch(savePersonalInfo_Success(true));
        dispatch(checkPersonelInformation_Success(true));
        dispatch(loading.hideLoading());

        if (obj.adresiVarMi) {
          history.push("/Home/NewAddress");
        } else {
          sendSmsOfferValidation();
          history.push("/Home/SmsVerification");
        }
      } else {
        dispatch(savePersonalInfo_Success(false));
        dispatch(loading.hideLoading());
        dispatch(
          alertActions.showError(
            response?.return !== null
              ? response?.return
              : "Beklenmeyen bir hata oluştu."
          )
        );
      }
    },
    (error) => {
      //dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  );
};

const savePersonalInfo_Success = (isAddressModalOpen) => ({
  type: calculationTypes.SAVEADDRESS_SUCCESS,
  payload: {
    isAddressModalOpen,
  },
});

export const saveAddress_Begin = (obj) => (dispatch) => {
  dispatch(loading.showLoading());
  saveAddress(obj).then(
    () => {
      dispatch(saveAddress_Success(true));
      dispatch(customerHasAddress_Success(true));
      dispatch(loading.hideLoading());
    },
    () => {
      dispatch(saveAddress_Success(false));
      //dispatch(alertActions.error(error));
      dispatch(loading.hideLoading());
    }
  );
};

const saveAddress_Success = (isAddressModalOpen) => ({
  type: calculationTypes.SAVEADDRESS_SUCCESS,
  payload: {
    isAddressModalOpen,
  },
});

export const setSelectedCampaign = (selectedCampaign) => ({
  type: calculationTypes.SET_SELECTED_CAMPAIGN,
  payload: {
    selectedCampaign,
  },
});

export const checkIfCustomerHasAddress_Begin = () => (dispatch) => {
  dispatch(loading.showLoading());
  checkIfCustomerHasAddress().then(
    (result) => {
      dispatch(customerHasAddress_Success(result));
      dispatch(loading.hideLoading());
    },
    (error) => {
      dispatch(alertActions.error(error));
      dispatch(loading.hideLoading());
    }
  );
};

export const customerHasAddress_Success = (hasAddress) => ({
  type: calculationTypes.CUSTOMER_HAS_ADDRESS,
  payload: {
    hasAddress,
  },
});

export const checkPersonelInformation_Begin = () => (dispatch) => {
  dispatch(loading.showLoading());
  checkPersonalInformation().then(
    (result) => {
      dispatch(checkPersonelInformation_Success(result));
      dispatch(loading.hideLoading());
    },
    (error) => {
      dispatch(alertActions.error(error));
      dispatch(loading.hideLoading());
    }
  );
};

export const checkPersonelInformation_Success = (hasPersonalInfo) => ({
  type: calculationTypes.CUSTOMER_HAS_PERSONEL_INFO,
  payload: {
    hasPersonalInfo,
  },
});

export const saveMembership_Begin = (obj) => (dispatch) => {
  dispatch(loading.showLoading());
  saveMembership(obj).then(
    (result) => {
      if (result.code === 200) {
        dispatch(saveMembership_Success(true));
        dispatch(setCandidateCustomerState(false));
        history.push("/Home/Result");
      } else {
        dispatch(saveMembership_Success(false));
        dispatch(saveMembership_Error(result.return));
        dispatch(alertActions.showError(result.return));
      }
      dispatch(loading.hideLoading());
    },
    () => {
      dispatch(saveAddress_Success(false));
      dispatch(alertActions.showError("Bir hata oluştu!"));
      dispatch(loading.hideLoading());
    }
  );
};

export const saveMembership_Success = (isCandidateProcessCompleted) => ({
  type: calculationTypes.SAVE_MEMBERSHIP_SUCCESS,
  payload: {
    isCandidateProcessCompleted,
  },
});

export const saveMembership_Error = (error) => ({
  type: calculationTypes.SAVE_MEMBERSHIP_ERROR,
  payload: {
    error,
  },
});
